import { create } from 'zustand';

import { MessageWithTextAndCitations } from '@services/types';

export type SetMessagesFunction = (
    updater: (messages: MessageWithTextAndCitations[]) => MessageWithTextAndCitations[]
) => void;

interface MessagesState {
    sessionId: string;
    messages: MessageWithTextAndCitations[];
    setMessages: SetMessagesFunction;
    resetChatHistory: () => void;
}

export const useMessagesStore = create<MessagesState>((set) => ({
    sessionId: crypto.randomUUID(),
    messages: [],
    setMessages: (updaterFcn) => set((state) => ({ messages: updaterFcn(state.messages) })),
    resetChatHistory: () =>
        set(() => ({
            sessionId: crypto.randomUUID(),
            messages: [],
        })),
}));
